import { render, staticRenderFns } from "./PhoneRegister.vue?vue&type=template&id=14bcd037&"
import script from "./PhoneRegister.vue?vue&type=script&lang=js&"
export * from "./PhoneRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhoneRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports